import { createRouter, createWebHistory } from 'vue-router';
import Registration from '@/views/RegistrationView';
import SuccessPage from '@/views/StatusPage/SuccessView';
import ErrorPage from '@/views/StatusPage/Error500View';

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes: [
		{
			path: '/:catchAll(.*)',
			name: 'Registration',
			component: Registration,
		},
		{
			path: '/Success',
			name: 'SuccessPage',
			component: SuccessPage,
		},
		{
			path: '/Error',
			name: 'ErrorPage',
			component: ErrorPage,
		},
	],
	scrollBehavior() {
		return { top: 0 };
	},
});

export default router;
